import TopBar from './components/navigation/TopBar.vue';
import MenuBar from './components/navigation/menu-bar/MenuBar.vue';
import Table from './components/Table.vue';
import ChipsChoice from './components/chips/ChipsChoice.vue';
import CameraLabel from './components/floorplan/CameraLabel.vue';
import ChipsFilter from './components/chips/ChipsFilter/ChipsFilter.vue';
import ChipsInput from './components/chips/ChipsInput.vue';
import ChipsInfo from './components/chips/ChipsInfo.vue';
import SideBar from './components/navigation/SideBar/SideBar.vue';
import MovableFilterSidebar from './components/navigation/MovableFilterSidebar/MovableFilterSidebar.vue';
import NavigationFooter from './components/navigation/NavigationFooter/NavigationFooter.vue';
import CheckBox from './components/selection-controls/CheckBox.vue';
import RadioButtonGroup from './components/selection-controls/RadioButtonGroup.vue';
import SelectBox from './components/dropdowns/SelectBox.vue';
import DragAndDrop from './components/DragAndDrop/DragAndDrop.vue';
import DraggableComponentList from './components/DragAndDrop/DraggableComponentList.vue';
import SortableList from './components/DragAndDrop/SortableList.vue';
import SortDropDown from './components/dropdowns/SortDropDown.vue';
import SwitchButton from './components/selection-controls/SwitchButton.vue';
import AlertDialog from './components/dialogs/AlertDialog.vue';
import BannerDialog from './components/dialogs/BannerDialog.vue';
import ButtonCommon from './components/buttons/ButtonCommon.vue';
import ButtonGroup from './components/buttons/ButtonGroup/ButtonGroup.vue';
import ConfirmationDialog from './components/dialogs/ConfirmationDialog.vue';
import DropDownMenu from './components/dropdowns/DropDownMenu.vue';
import AutoComplete from './components/dropdowns/AutoComplete.vue';
import DropDownTelephone from './components/dropdowns/DropdownTelephone.vue';
import LoadingSpinner from './components/loaders/LoadingSpinner.vue';
import NotificationDialog from './components/dialogs/NotificationDialog.vue';
import NotificationProgressDialog from './components/dialogs/NotificationProgressDialog.vue';
import SliderSimple from './components/SliderSimple.vue';
import TextArea from './components/text-inputs/TextArea.vue';
import TextField from './components/text-inputs/TextField.vue';
import TooltippedText from './components/tooltip/TooltippedText/TooltippedText.vue';
import Tooltip from './components/tooltip/Tooltip.vue';
import ShowMore from './components/ShowMore.vue';
import Skeleton from './components/loaders/Skeleton.vue';
import SidebarSkeleton from './components/loaders/SidebarSkeleton.vue';
import PageTitle from './components/PageTitle/PageTitle.vue';
import FormField from './components/FormField.vue';
import EmptyState from './components/EmptyState/EmptyState.vue';
import DatePicker from './components/datePicker/DatePicker.vue';
import TimePicker from './components/timePicker/TimePicker.vue';
import RecordedView from './components/recorded-view/RecordedView.vue';
import Counter from './components/Counter.vue';
import Breadcrumbs from './components/navigation/Breadcrumbs.vue';
import ChipsSelect from './components/chips/ChipsSelect.vue';
import ChipsAutoselect from './components/chips/ChipsAutocomplete.vue';
import FormFieldBlock from './components/FormFieldBlock/FormFieldBlock.vue';
import DonutChart from './components/DonutChart.vue';
import SearchBar from './components/text-inputs/searchBar/SearchBar.vue';
import SortableTreeTable from './components/SortableTreeTable/SortableTreeTable.vue';
import ProgressBarSteps from './components/ProgressBarSteps.vue';
import ProgressBar from './components/ProgressBar.vue';
import UploadFile from './components/UploadFile.vue';
import FloorplanPreviewMarker from './components/floorplans/FloorplanPreviewMarker/FloorplanPreviewMarker.vue';
import DRR from './components/floorplans/DraggableResizableRotatable.vue';
import VerificationCode from './components/verification-code/VerificationCode.vue';
import SettingsPage from './components/SettingsPage/SettingsPage.vue';
import MultiSelectSearch from './components/dropdowns/MultiSelectSearch/MultiSelectSearch.vue';
import MultiSelectSearchPaginated from './components/dropdowns/MultiSelectSearchPaginated/MultiSelectSearchPaginated.vue';
import MultiSelect from './components/dropdowns/MultiSelect/MultiSelect.vue';
import RangeSlider from './components/sliders/RangeSlider/RangeSlider.vue';
import DropdownRangeSlider from './components/dropdowns/DropdownRangeSlider/DropdownRangeSlider.vue';
import TreeView from './components/TreeView/TreeView.vue';
import DropdownMenuChip from './components/chips/DropdownMenuChip/DropdownMenuChip.vue';
import ActionCard from './components/cards/ActionCard/ActionCard.vue';
import ImageViewer from './components/ImageViewer/ImageViewer.vue';
import VideoSearchbar from './components/text-inputs/searchBar/VideoSearchbar/VideoSearchbar.vue';
import MessageBanner from './components/dialogs/MessageBanner/MessageBanner.vue';
import ExpansionPanels from './components/ExpansionPanels/ExpansionPanels.vue';
import ExpansionPanel from './components/ExpansionPanels/ExpansionPanel.vue';
import DateTimePicker from './components/dateTimeRangePicker/DateTimePicker.vue';
import Separator from './components/separator/Separator.vue';
import DropdownRangeInput from './components/dropdowns/DropdownRangeSelectSearch/DropdownRangeInput.vue';
import Tabs from './components/tabs/Tabs.vue';
import FaceImage from './components/FaceImage/FaceImage.vue';
import CarouselScreen from './components/carouselScreen/CarouselScreen.vue';
import Modal from './components/dialogs/Modal.vue';
import Popover from './components/text-inputs/Popover.vue';
import SnackbarNotification from './components/dialogs/SnackbarNotification.vue';
import EditableTable from './components/EditableTable.vue';
import ProfileMenu from './components/ProfileMenu/ProfileMenu.vue';
import AppSwitcher from './components/appSwitcher/AppSwitcher.vue';
import SingleSelectSearch from './components/dropdowns/SingleSelectSearch.vue';
import ConditionSelector from './components/dropdowns/ConditionSelector/ConditionSelector.vue';
import PreviewStatusCard from './components/previewStatusCard/PreviewStatusCard.vue';

export default {
  install(Vue) {
    Vue.component('EewcNavigationFooter', NavigationFooter);
    Vue.component('EewcNavigationTopbar', TopBar);
    Vue.component('EewcNavigationMenubar', MenuBar);
    Vue.component('EewcTable', Table);
    Vue.component('EewcAutoComplete', AutoComplete);
    Vue.component('EewcSelectBox', SelectBox);
    Vue.component('EewcSortDropdown', SortDropDown);
    Vue.component('EewcButtonCommon', ButtonCommon);
    Vue.component('EewcChipsChoice', ChipsChoice);
    Vue.component('EewcChipsFilter', ChipsFilter);
    Vue.component('EewcChipsInput', ChipsInput);
    Vue.component('EewcChipsInfo', ChipsInfo);
    Vue.component('EewcSidebar', SideBar);
    Vue.component('EewcMovableFilterSidebar', MovableFilterSidebar);
    Vue.component('EewcMenuBar', MenuBar);
    Vue.component('EewcCheckBox', CheckBox);
    Vue.component('EewcRadiobuttonGroup', RadioButtonGroup);
    Vue.component('EewcSwitchButton', SwitchButton);
    Vue.component('EewcAlertDialog', AlertDialog);
    Vue.component('EewcLoadingSpinner', LoadingSpinner);
    Vue.component('EewcButtonGroup', ButtonGroup);
    Vue.component('EewcBannerDialog', BannerDialog);
    Vue.component('EewcConfirmationDialog', ConfirmationDialog);
    Vue.component('EewcDropdownMenu', DropDownMenu);
    Vue.component('EewcDropdownTelephone', DropDownTelephone);
    Vue.component('EewcNotificationDialog', NotificationDialog);
    Vue.component('EewcNotificationProgress', NotificationProgressDialog);
    Vue.component('EewcSliderSimple', SliderSimple);
    Vue.component('EewcTextArea', TextArea);
    Vue.component('EewcTextField', TextField);
    Vue.component('EewcSkeleton', Skeleton);
    Vue.component('EewcSidebarSkeleton', SidebarSkeleton);
    Vue.component('EewcPageTitle', PageTitle);
    Vue.component('EewcFormField', FormField);
    Vue.component('EewcTooltippedText', TooltippedText);
    Vue.component('EewcTooltip', Tooltip);
    Vue.component('EewcShowMore', ShowMore);
    Vue.component('EewcEmptyState', EmptyState);
    Vue.component('EewcPickerDate', DatePicker);
    Vue.component('EewcPickerTime', TimePicker);
    Vue.component('EewcRecordedView', RecordedView);
    Vue.component('EewcCounter', Counter);
    Vue.component('EewcNavigationBreadcrumbs', Breadcrumbs);
    Vue.component('EewcChipsSelect', ChipsSelect);
    Vue.component('EewcChipsAutoselect', ChipsAutoselect);
    Vue.component('EewcFormFieldBlock', FormFieldBlock);
    Vue.component('EewcDonutChart', DonutChart);
    Vue.component('EewcSearchbar', SearchBar);
    Vue.component('EewcDrr', DRR);
    Vue.component('EewcCameraLabel', CameraLabel);
    Vue.component('EewcFloorplanPreviewMarker', FloorplanPreviewMarker);
    Vue.component('EewcSortableTreeTable', SortableTreeTable);
    Vue.component('EewcProgressBarSteps', ProgressBarSteps);
    Vue.component('EewcProgressBar', ProgressBar);
    Vue.component('EewcUploadFile', UploadFile);
    Vue.component('EewcDragAndDrop', DragAndDrop);
    Vue.component('EewcDraggableComponentList', DraggableComponentList);
    Vue.component('EewcVerificationCode', VerificationCode);
    Vue.component('EewcSortableList', SortableList);
    Vue.component('EewcSettingsPage', SettingsPage);
    Vue.component('EewcMultiselectSearch', MultiSelectSearch);
    Vue.component('EewcMultiselectSearchPaginated', MultiSelectSearchPaginated);
    Vue.component('EewcMultiselect', MultiSelect);
    Vue.component('EewcRangeSlider', RangeSlider);
    Vue.component('EewcDropdownRangeSlider', DropdownRangeSlider);
    Vue.component('EewcTreeView', TreeView);
    Vue.component('EewcDropdownMenuChip', DropdownMenuChip);
    Vue.component('EewcActionCard', ActionCard);
    Vue.component('EewcImg', ImageViewer);
    Vue.component('EewcVideoSearchbar', VideoSearchbar);
    Vue.component('EewcMessageBanner', MessageBanner);
    Vue.component('EewcExpansionPanels', ExpansionPanels);
    Vue.component('EewcExpansionPanel', ExpansionPanel);
    Vue.component('EewcPickerDateTime', DateTimePicker);
    Vue.component('EewcSeparator', Separator);
    Vue.component('EewcDropdownRangeInput', DropdownRangeInput);
    Vue.component('EewcFaceImage', FaceImage);
    Vue.component('EewcTabs', Tabs);
    Vue.component('EewcCarouselScreen', CarouselScreen);
    Vue.component('EewcModal', Modal);
    Vue.component('EewcPopover', Popover);
    Vue.component('EewcSnackbarNotification', SnackbarNotification);
    Vue.component('EewcEditableTable', EditableTable);
    Vue.component('EewcProfileMenu', ProfileMenu);
    Vue.component('EewcAppSwitcher', AppSwitcher);
    Vue.component('EewcSingleSelectSearch', SingleSelectSearch);
    Vue.component('EewcConditionSelector', ConditionSelector);
    Vue.component('EewcPreviewStatusCard', PreviewStatusCard);
  },
};
